import { useReactiveVar } from '@apollo/client'
import { RockpoolItemFilter } from '@appTypes/RockpoolTypes'
import { SaleTypesIcons } from '@components/shared/Icon'
import { rockpoolFiltersVar } from '@graphql/variables/RockPoolVariables'
import { useLocalStorage } from '@hooks/LocalStorageHooks'
import { useRouteParams, useRouteRockpoolSaleType } from '@hooks/RouteHooks'
import { useEffect } from 'react'
import TagButton from '../shared/buttons/TagButton'

export default function RockpoolTypeFilter() {
  const filters = useReactiveVar(rockpoolFiltersVar)
  const { setItem } = useRouteParams()
  const handleLocalStorage = useLocalStorage()

  const saleTypes = [
    {
      id: RockpoolItemFilter.live,
      name: 'Live',
      image: SaleTypesIcons.all,
      action() {
        setSaleType(RockpoolItemFilter.live)
      }
    },
    {
      id: RockpoolItemFilter.winner,
      name: 'Winner',
      image: SaleTypesIcons.all,
      action() {
        setSaleType(RockpoolItemFilter.winner)
      }
    }
  ]
  const setSaleType = (value: RockpoolItemFilter) => {
    rockpoolFiltersVar({ ...filters, type: value })
    setItem('saleType', value)
    handleLocalStorage.setItem('saleType', value)
  }

  const routeSaleType = useRouteRockpoolSaleType()

  useEffect(() => {
    handleLocalStorage.setItem('saleType', String(routeSaleType))
  }, [handleLocalStorage, routeSaleType])

  useEffect(() => {
    rockpoolFiltersVar({ ...rockpoolFiltersVar(), type: routeSaleType })
  }, [routeSaleType])

  return (
    <>
      {saleTypes.map(saleType => (
        <TagButton key={saleType.id} active={saleType.id === routeSaleType} onClick={saleType.action} name={saleType.name} />
      ))}
    </>
  )
}
